var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53806 0.934439C9.43699 0.729636 9.2284 0.599976 9.00002 0.599976C8.77163 0.599976 8.56305 0.729636 8.46198 0.934439L6.00572 5.91142L0.513792 6.70895C0.287768 6.74177 0.09998 6.90007 0.0293921 7.11728C-0.0411958 7.3345 0.0176593 7.57295 0.181209 7.73237L4.15532 11.6062L3.21691 17.0767C3.17829 17.3018 3.27083 17.5293 3.4556 17.6636C3.64037 17.7978 3.88533 17.8155 4.08749 17.7092L9.00002 15.1264L13.9125 17.7092C14.1147 17.8155 14.3597 17.7978 14.5444 17.6636C14.7292 17.5293 14.8217 17.3018 14.7831 17.0767L13.8447 11.6062L17.8188 7.73237C17.9824 7.57295 18.0412 7.3345 17.9706 7.11728C17.9001 6.90007 17.7123 6.74177 17.4862 6.70895L11.9943 5.91142L9.53806 0.934439Z",
    fill: "#FFC922"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.045701457f9462c903cf080f4814f66d.svg";
export { ForwardRef as ReactComponent };